import React from 'react';
import { portfolioData } from '../mockData';

const Education = () => {
  const { education } = portfolioData;

  return (
    <section id="education">
      <h2 className="label reveal">Education</h2>
      <div className="entry-list">
        {education.map((item) => (
          <div className="entry reveal" key={item.degree}>
            <span className="badge">{item.graduation}</span>
            <div className="entry-header">
              <img src={item.logo} alt={`${item.institution} logo`} className="entry-logo" />
              <h3 className="entry-title">{item.institution}</h3>
            </div>
            <div className="entry-sub">{item.degree} · {item.location}</div>
            <p className="entry-desc">{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Education;
